import 'moment/locale/id';
import { FC, useEffect, useState, ReactNode } from "react"
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { TableColumn } from "react-data-table-component";
import moment from "moment";
import useUser from '../../../hooks/User'
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Reimburse } from '../../../interfaces/Reimbursement';
import { currencyFormatter, customThousandSeparatorDot, isColorDarkFromHex } from '../../../functions/general';
import { AddReimbursement } from '../../../components/Reimbursement/AddReimbursement';
import { DeleteReimbursement } from '../../../components/Reimbursement/DeleteReimbursement';
import { UpdateReimbursement } from '../../../components/Reimbursement/UpdateReimbursement';
import { ApproveReimbursement } from '../../../components/Reimbursement/ApproveReimbursement';
import { RejectReimbursement } from '../../../components/Reimbursement/RejectReimbursement';
import { PayOffReimbursement } from '../../../components/Reimbursement/PayOffReimbursement';
import { FilterReimbursement } from '../../../components/Reimbursement/FilterReimbursement';
import { DetailReimbursement } from '../../../components/Reimbursement/DetailReimbursement';
import { useIntl } from 'react-intl';
import { DateRangePicker } from 'rsuite';
import usePredefinedRanges from '../../../hooks/PredefinedRanges';
import useCalendarLocale from '../../../hooks/CalendarLocale';
import { endOfMonth, startOfMonth } from 'date-fns';
import useSWR, { mutate } from 'swr';
import { useSettingsStore } from '../../../stores/SettingsStore';
import { DetailMeeting } from '../../../components/Meetings/DetailMeeting';
import { DetailMerchant } from '../../../components/Merchants/DetailMerchant';
import useDynamicTab from '../../../hooks/useDynamicTab';
import axios from 'axios';
import useAccessToken from '../../../hooks/AccessToken';
import useRedirectRouteNotif from '../../../stores/RedirectRouteNotif';
import { useParams } from 'react-router-dom';
import { useReimbursementStore } from '../../../stores/ReimbursementStore';
import { CustomField } from '../../../interfaces/Settings';
import { ExpandableElement } from '../../../components/General/ExpandableElement';
import useModalEffect from '../../../hooks/useModalEffect';
import { ModalAttachmentCustomField } from '../../../components/ModalGeneral/ModalAttachmentCustomField';
import { isAllowApproveReimburse, isAllowUploadPaymentReimburse } from '../../../functions/reimbursement';
import BadgeTooltip from '../../../components/General/BadgeTooltip';
import { DataTableExport } from '../../../components/DataTable/DataTableExport';
import { defaultScope, UserScopeModal } from '../../../components/DataTable/UserScopeModal';
import { UserScope } from '../../../interfaces/UserScope';

const API_URL = process.env.REACT_APP_API_URL

const Reimbursement: FC = () => {
    const { templateReimbursementId } = useParams()
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showApproveModal, setShowApproveModal] = useState<boolean>(false);
    const [showRejectModal, setShowRejectModal] = useState<boolean>(false);
    const [showPayOffModal, setShowPayOffModal] = useState<boolean>(false);
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
    const [showDetailMeetingModal, setShowDetailMeetingModal] = useState<boolean>(false);
    const [showDetailMerchantModal, setShowDetailMerchantModal] = useState<boolean>(false);
    const { remainingLimitMonth, remainingLimitYear, multiReimbursements, setSelectMultiReimbursement, selectMultiReimbursement } = useReimbursementStore()
    const [reimburse, setReimburse] = useState<Reimburse>();
    const [manageColumns, setManageColumns] = useState<TableColumn<Reimburse>[]>([]);
    const [customFields, setCustomFields] = useState<CustomField>({})
    const user = useUser()
    const { settings } = useSettingsStore()
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const intl = useIntl()
    const predefinedRanges = usePredefinedRanges();
    const calendarLocale = useCalendarLocale();
    const today = new Date()
    const [startDate, setStartDate] = useState<Date>(startOfMonth(today));
    const [endDate, setEndDate] = useState<Date>(endOfMonth(today));
    const [loading, setLoading] = useState<boolean>(true);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const token = useAccessToken()
    const { getTemplateId, clearRedirectRouteNotif } = useRedirectRouteNotif()
    const template = getTemplateId() || { id: '', templateId: '' }
    const [showAttachmentModal, setShowAttachmentModal] = useState<boolean>(false);
    const [key, setKey] = useState<string>('');
    const [url, setUrl] = useState<string | string[]>('');
    const [user_id, setUser_id] = useState<string>(user.data.id);
    const [user_name, setUser_name] = useState<string>(user.data.name);
    const [scope, setScope] = useState<UserScope>(defaultScope(user.data.permission_reimbursement_read));

    const handleClick = (menuId: string) => {
        setOpenMenuId(menuId);
    };
    const handleClose = () => {
        setOpenMenuId(null);
    };

    const tableColumns: TableColumn<Reimburse>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            center: true,
            width: '70px',
            cell: (row) => {
                return (
                    <>
                        {
                            <>
                                <IconButton
                                    aria-label={`more-${row.id}`}
                                    id={`menu-anchor-${row.id}`}
                                    onClick={() => handleClick(row.id)}
                                >
                                    <MoreVertIcon />
                                </IconButton>

                                <Menu
                                    id={`menu-${row.id}`}
                                    anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
                                    open={openMenuId === row.id}
                                    onClose={handleClose}
                                    disableScrollLock={true}
                                >
                                    <MenuItem onClick={() => {
                                        handleClose();
                                        setReimburse(row);
                                        setShowDetailModal(true);
                                    }}>
                                        <i className="fas fa-info-circle fs-4 me-4"></i>
                                        <span>{intl.formatMessage({ id: 'FORM.ACTION.DETAIL' })}</span>
                                    </MenuItem>

                                    {(!user.data.is_superadmin || user.data.permission_reimbursement_update !== 'NONE') && user.data.id === row.userOwner.id && row.approvalStatus === 'PENDING' &&
                                        <MenuItem onClick={() => {
                                            handleClose();
                                            setShowUpdateModal(true);
                                            setReimburse(row);
                                        }}>
                                            <i className="fas fa-edit fs-4 me-4"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}</span>
                                        </MenuItem>
                                    }

                                    {(!user.data.is_superadmin || user.data.permission_reimbursement_delete !== 'NONE') && user.data.id === row.userOwner.id && row.approvalStatus === 'PENDING' &&
                                        <MenuItem onClick={() => {
                                            handleClose();
                                            setShowDeleteModal(true);
                                            setReimburse(row);
                                        }}>
                                            <i className="fas fa-trash fs-3 me-5"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.DELETE' })}</span>
                                        </MenuItem>
                                    }

                                    {isAllowApproveReimburse(user) && row.approvalStatus === 'PENDING' &&
                                        <MenuItem onClick={() => {
                                            handleClose();
                                            setShowApproveModal(true);
                                            setReimburse(row);
                                        }}>
                                            <i className="fas fa-check-circle fs-3 me-5 text-success"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.APPROVE' })}</span>
                                        </MenuItem>
                                    }

                                    {isAllowApproveReimburse(user) && row.approvalStatus === 'PENDING' &&
                                        <MenuItem onClick={() => {
                                            handleClose();
                                            setShowRejectModal(true);
                                            setReimburse(row);
                                        }}>
                                            <i className="fas fa-times-circle fs-3 me-5 text-danger"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.REJECT' })}</span>
                                        </MenuItem>
                                    }

                                    {isAllowUploadPaymentReimburse(user) && row.approvalStatus === 'APPROVED' &&
                                        <MenuItem onClick={() => {
                                            handleClose();
                                            setShowPayOffModal(true);
                                            setReimburse(row);
                                        }}>
                                            <i className="fas fa-file-upload fs-3 me-5"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.UPLOAD_PROOF_OF_PAYMENT' })}</span>
                                        </MenuItem>
                                    }
                                </Menu>
                            </>
                        }
                    </>
                )
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_SUBMITTED' }),
            selector: row => row.dateCreated,
            sortable: true,
            width: '200px',
            cell: row => moment(row.dateCreated).format('DD MMMM YYYY'),
            style: {
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NAME' }),
            selector: row => row.name?.toLowerCase(),
            width: '250px',
            sortable: true,
            cell: (row) => {
                return (
                    row.reference.type !== 'NONE' ?
                        <>
                            {row.name}
                            <span className="badge badge-light-primary ms-3" >{row.reference.type === 'MEETING' ? settings.meeting_title : settings.merchant_title}</span>
                        </>
                        :
                        <span>{row.name}</span>
                )
            },
            style: {
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CATEGORY' }),
            width: '200px',
            selector: row => row.categoryName?.toLowerCase(),
            sortable: true,
            cell: (row) => {
                const color = row.reimbursementCategory.color;

                // Determine the badge style based on progress color
                const badgeStyle = color
                    ? { backgroundColor: color, color: isColorDarkFromHex(color) ? "white" : "black" }
                    : { backgroundColor: "transparent", }; // Default when no color

                return (
                    <BadgeTooltip tooltipText={row.categoryName} badgeClass={`my-2 mx-1 ${color ? '' : 'badge-light-info'}`} style={badgeStyle}>
                        {row.categoryName}
                    </BadgeTooltip>
                );
            },
            style: {
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOMINAL' }),
            width: '170px',
            style: {
                justifyContent: 'right',
                '&:hover': {
                    cursor: 'pointer'
                }
            },
            selector: row => row.value,
            sortable: true,
            cell(row) {
                if (row.companyCurrency.code === "USD") {
                    return (
                        <span>{row.value && currencyFormatter(row.value, false, "USD", { showPrefix: true })}</span>
                    )
                } else {
                    return (
                        <span>{row.value && currencyFormatter(row.value, true, "IDR", { showPrefix: true })}</span>
                    )
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.USER' }),
            selector: row => row.userOwner.name,
            sortable: true,
            omit: (user.data.is_superadmin === false && user.data.canApproveReimbursement === false && user.data.canUploadReimbursementProofOfPayment === false),
            cell: row => row.userOwner.name,
            style: {
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.STATUS' }),
            selector: row => row.approvalStatus,
            sortable: true,
            width: '150px',
            cell(row) {
                switch (row.approvalStatus) {
                    case 'REJECTED':
                        return <span className="badge badge-light-danger">{intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.REJECTED' })}</span>
                    case 'APPROVED':
                        return <span className="badge badge-light-success">{intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.APPROVED' })}</span>
                    case 'PAID_OFF':
                        return <span className="badge badge-light-primary">{intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.PAID_OFF' })}</span>
                    default:
                        return <span className="badge badge-light-warning">{intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.PENDING' })}</span>
                }
            },
            style: {
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
    ];

    const tableColumnsWithCustomFields: TableColumn<Reimburse>[] = [
        ...tableColumns,
        ...Object.keys(customFields).map((key, index) => {
            if (customFields[key].type === 'number') {
                return {
                    name: customFields[key].name,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? customThousandSeparatorDot(row.customFields[key] as unknown as number) : '-'
                    },
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return customThousandSeparatorDot(row.customFields[key] as unknown as number)
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'date') {
                return {
                    id: key,
                    width: "150px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                moment(row.customFields[key]).format("DD MMM YYYY")
                            )
                        } else {
                            return '-'
                        }
                    }
                };
            } else if (customFields[key].type === 'image' || customFields[key].type === 'images') {
                return {
                    id: key,
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-'
                    },
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <span role="button" onClick={
                                    () => {
                                        setShowAttachmentModal(true);
                                        setReimburse(row);
                                        setKey(key);
                                        setUrl(row.customFields[key] as any);
                                    }
                                }>
                                    <i className="fas fs-2 fa-eye"></i>
                                </span>
                            )
                        } else {
                            return '-'
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'file' || customFields[key].type === 'files' || customFields[key].type === 'video' || customFields[key].type === 'videos') {
                return {
                    id: key,
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-'
                    },
                    cell(row: Reimburse) {
                        const fileUrl = row.customFields && row.customFields[key];
                        if (typeof fileUrl === "string") {
                            return fileUrl ? (
                                <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="ms-2 btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                >
                                    <i className="fas fa-file-invoice fs-3 float-end"></i>
                                </a>
                            ) : '-';
                        } else {
                            return fileUrl ? (
                                <span role="button" onClick={() => {
                                    setShowAttachmentModal(true);
                                    setReimburse(row);
                                    setKey(key);
                                    setUrl(fileUrl as string[]);
                                }}>
                                    <i className="fas fa-file-invoice fs-3 float-end"></i>
                                </span>
                            ) : '-';
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'multiple' || customFields[key].type === 'multipleOption') {
                return {
                    id: key,
                    width: "150px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString()
                        if (customFields[key].type === 'multipleOption') {
                            return values ? (
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div>{values.split(',').join(', ')}</div>
                                </div>
                            ) : "-"
                        } else return values ? values.split(',').join(', ') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'link') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <a href={row.customFields[key] as string} rel="noreferrer" className="btn btn-sm btn-outline btn-outline-default btn-active-light text-gray-600" target="_blank">Lihat<i className="fas fa-external-link-alt fs-6 ms-2 p-0"></i></a>
                            )
                        } else return "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'serial') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.customFields && row.customFields[key];
                        return values ? (values as string[]).join('') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'merchant') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.merchant_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'pipeline') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return (
                                <div className="d-flex flex-column">
                                    <span><b>{(values[0] as any).name}</b> / </span>
                                    <span>{currencyFormatter((values[0] as any).nominal, user?.data?.companyCurrencyNeedRound, user?.data?.companyCurrency, { showPrefix: true })} / </span>
                                    <span>{moment((values[0] as any).dateStarted).format("DD MMM YYYY")}</span>
                                </div>
                            );
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'meeting') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status}`).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'user') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'link') {
                return {
                    id: key,
                    name: customFields[key].name,
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return (
                                <a href={row.customFields[key] as string} rel="noreferrer" className="btn btn-sm btn-outline btn-outline-default btn-active-light text-gray-600" target="_blank">{intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LINK' })}<i className="fas fa-external-link-alt fs-6 ms-2 p-0"></i></a>
                            )
                        } else return "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'dateTime') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-';
                    },
                    cell: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? moment(row.customFields[key]).format('DD MMM YYYY HH:mm') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    width: "200px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'dateTimeRange') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? (row.customFields[key] as string[]).map((item: any) => item).join(' - ') : '-'
                    },
                    width: "200px",
                    cell: (row: Reimburse) => {
                        if (row.customFields && row.customFields[key]) {
                            return Array.isArray(row.customFields[key]) && (row.customFields[key] as string[]).map((item: any) => moment(item).format('DD MMM YYYY HH:mm')).join(' - ')
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'time') {
                return {
                    id: key,
                    name: customFields[key].name,
                    width: '150px',
                    selector: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key] as string : '-';
                    },
                    cell: (row: Reimburse) => {
                        return row.customFields && row.customFields[key] ? moment(row.customFields[key]).format('HH:mm') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'option') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Reimburse) => {
                        const fieldValue = row.customFields && (row.customFields[key] as string);
                        const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                            ? '-'
                            : fieldValue;

                        return displayValue || '-';
                    },
                    cell: (row: Reimburse) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString();
                        return values ? (
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {values.split('\n').map((line, idx) => (
                                    <div key={idx}>{line}</div>
                                ))}
                            </div>
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'product') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: any) => {
                        return row.customFields && row.customFields[key] ? row.customFields[key].toString() : '-'
                    },
                    cell: (row: any) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.product_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'paragraph') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Reimburse) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Reimburse) => {
                        const values = row.customFields && row.customFields[key] && row.customFields[key].toString();
                        return values ? (
                            <ExpandableElement
                                content={
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                        {values}
                                    </div>
                                }
                                maxHeight={100}
                            />
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            }
            return {
                id: key,
                width: "150px",
                name: customFields[key].name,
                style: { cursor: "pointer" },
                selector: (row: Reimburse) => {
                    // Check if row.customFields is defined and not null
                    const fieldValue = row.customFields && row.customFields[key];

                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return (displayValue as string)?.toLowerCase() || '-';
                },
                allowOverflow: true,
                sortable: true,
                omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                cell: (row: Reimburse) => {
                    // Check if row.customFields is defined and not null
                    const fieldValue = row.customFields && row.customFields[key];

                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return displayValue || '-';
                },
                reorder: true
            };
        }),
    ];

    let actions: ReactNode[] = []
    if (!user.data.is_superadmin && user.data.permission_reimbursement_create !== 'NONE') actions.push(<AddReimbursement />)
    if (user.data.is_allowed_export_excel) {
        actions.push(<DataTableExport source={"Reimbursement"} columns={manageColumns} />)
    }
    actions.push(<FilterReimbursement />)

    const onRowClicked = (row: any, event: any) => {
        setReimburse(row)
        setShowDetailModal(true);
    };

    useEffect(() => {
        setManageColumns(tableColumnsWithCustomFields);
    }, [customFields])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 666) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const fetcher = async (url: string) => {
        const response = await axios.get(url, {
            headers: {
                'X-Auth-token': token,
            },
        });
        return response.data.data;
    };

    const { data: reimbursements = {}, isLoading } = useSWR(template.id ? `${API_URL}reimbursement/${template.id}` : null, fetcher);

    useEffect(() => {
        if (!isLoading) {
            if (reimbursements && Object.keys(reimbursements).length > 0) {
                setShowDetailModal(true)
                setReimburse(reimbursements)
            }

            if (reimburse) clearRedirectRouteNotif()
        }
        return () => {
            setShowDetailModal(false)
            setReimburse({} as Reimburse)
        }
    }, [isLoading, showDetailModal])

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: `update-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showDeleteModal,
        setShowModal: setShowDeleteModal,
        modalId: `delete-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showApproveModal,
        setShowModal: setShowApproveModal,
        modalId: `approve-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showRejectModal,
        setShowModal: setShowRejectModal,
        modalId: `reject-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showPayOffModal,
        setShowModal: setShowPayOffModal,
        modalId: `payoff-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showDetailModal,
        setShowModal: setShowDetailModal,
        modalId: `detail-reimbursement-modal-${reimburse?.id}`
    })

    useModalEffect({
        showModal: showDetailMeetingModal,
        setShowModal: setShowDetailMeetingModal,
        modalId: `detail-meeting-modal`
    })

    useModalEffect({
        showModal: showDetailMerchantModal,
        setShowModal: setShowDetailMerchantModal,
        modalId: `detail-merchant-modal-${reimburse?.reference?.id}`
    })

    useModalEffect({
        showModal: showAttachmentModal,
        setShowModal: setShowAttachmentModal,
        modalId: `attachments-custom-field-modal-${reimburse?.id}`
    })

    useEffect(() => {
        if (startDate && endDate) {
            mutate(`${API_URL}${isAllowApproveReimburse(user) || isAllowUploadPaymentReimburse(user) ? `reimbursements?reimbursementTemplateId=${templateReimbursementId}` : `my-reimbursements?reimbursementTemplateId=${templateReimbursementId}`}`);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (templateReimbursementId && multiReimbursements.length > 0) {
            const data = multiReimbursements.find(item => item.id === templateReimbursementId)
            setSelectMultiReimbursement(data!)
            setStartDate(startOfMonth(today))
            setEndDate(endOfMonth(today))
            setCustomFields(data?.customFields!);
        }
    }, [multiReimbursements, templateReimbursementId])

    useDynamicTab({ title: `${settings.reimbursement_title} | CRM WooBlazz` });

    return (
        <>
            <div className="d-flex justify-content-between mb-5">
                <ol className="text-muted breadcrumb fs-6 fw-bold">
                    <li className="text-muted breadcrumb-item">{settings.reimbursement_title}</li>
                    <li className="text-dark breadcrumb-item">{selectMultiReimbursement.name}</li>
                </ol>

                <DateRangePicker
                    cleanable={false}
                    character=" - "
                    format="dd MMM yyyy"
                    locale={calendarLocale}
                    value={[startDate, endDate]}
                    ranges={predefinedRanges}
                    placement="bottomEnd"
                    onChange={(value) => {
                        if (value && value.length === 2) {
                            setStartDate(value[0]);
                            setEndDate(value[1]);
                        }
                    }}
                    showOneCalendar={isMobile}
                    disabled={loading}
                    isoWeek={true}
                />
            </div>

            <div className={`d-flex ${(user.data.permission_reimbursement_read !== 'OWNED' && user.data.permission_reimbursement_read !== 'NONE') ? 'justify-content-between' : 'justify-content-end'}`}>
                {
                    (user.data.permission_reimbursement_read !== 'OWNED' && user.data.permission_reimbursement_read !== 'NONE') &&
                    <UserScopeModal
                        user_id={user_id}
                        setUser_id={setUser_id}
                        user_name={user_name}
                        setUser_name={setUser_name}
                        scope={scope} setScope={setScope}
                        permission={user.data.permission_reimbursement_read}
                        apiURL={isAllowApproveReimburse(user) || isAllowUploadPaymentReimburse(user) ? `reimbursements?reimbursementTemplateId=${templateReimbursementId}` : `my-reimbursements?reimbursementTemplateId=${templateReimbursementId}`}
                    />
                }

                <div className="d-flex align-items-center">
                </div>
            </div>

            {
                !user.data.is_superadmin && (
                    <div className="row g-5 g-xl-8">
                        <div className="col-xl-6">
                            <div className="card bg-primary card-xl-stretch mb-xl-8">
                                <div className="card-body">
                                    <div className="d-flex align-items-center d-flex gap-2 mb-2">
                                        <div className="text-white fw-bolder fs-2 counted">Rp {remainingLimitMonth.idr !== null ? currencyFormatter(remainingLimitMonth.idr) : "-"}</div>
                                        <div className="counted text-white">|</div>
                                        <div className="text-white fw-bolder fs-2 counted">$ {remainingLimitMonth.usd !== null ? currencyFormatter(remainingLimitMonth.usd) : "-"}</div>
                                    </div>
                                    <div className="fw-bold text-white">{intl.formatMessage({ id: "FORM.LABEL.REMAINING_REIMBURSEMENT_MONTH" })}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="card bg-success card-xl-stretch mb-5 mb-xl-8">
                                <div className="card-body">
                                    <div className="d-flex align-items-center d-flex gap-2 mb-2">
                                        <div className="text-white fw-bolder fs-2 counted">Rp {remainingLimitYear.idr !== null ? currencyFormatter(remainingLimitYear.idr) : "-"}</div>
                                        <div className="counted text-white">|</div>
                                        <div className="text-white fw-bolder fs-2 counted">$ {remainingLimitYear.usd !== null ? currencyFormatter(remainingLimitYear.usd) : "-"}</div>
                                    </div>
                                    <div className="fw-bold text-white">{intl.formatMessage({ id: "FORM.LABEL.REMAINING_REIMBURSEMENT_YEAR" })}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <MasterDataTable
                tableKey={isAllowApproveReimburse(user) || isAllowUploadPaymentReimburse(user) ? "reimbursements" : "my-reimbursements"}
                tableColumns={tableColumnsWithCustomFields}
                actions={actions}
                apiURL={isAllowApproveReimburse(user) || isAllowUploadPaymentReimburse(user) ? `reimbursements?reimbursementTemplateId=${templateReimbursementId}` : `my-reimbursements?reimbursementTemplateId=${templateReimbursementId}`}
                dateStart={moment(startDate).format('YYYY-MM-DD')}
                dateEnd={moment(endDate).format('YYYY-MM-DD')}
                orderBy={2}
                order="desc"
                onRowClicked={onRowClicked}
                setLoading={setLoading}
                user_id={user_id}
                scope={scope}
            />
            {
                showUpdateModal && <UpdateReimbursement reimburse={reimburse!} />
            }
            {
                showDeleteModal && <DeleteReimbursement reimburse={reimburse!} />
            }
            {
                showApproveModal && <ApproveReimbursement reimburse={reimburse!} />
            }
            {
                showRejectModal && <RejectReimbursement reimburse={reimburse!} />
            }
            {
                showPayOffModal && <PayOffReimbursement reimburse={reimburse!} />
            }
            {
                showDetailModal && <DetailReimbursement data={reimburse ? reimburse : {} as Reimburse} setShowDetailMeetingModal={setShowDetailMeetingModal} setShowDetailMerchantModal={setShowDetailMerchantModal} />
            }
            {
                showAttachmentModal && <ModalAttachmentCustomField id={reimburse!.id} title={customFields[key].name!} url={url} />
            }
            {
                showDetailMeetingModal && <DetailMeeting data={reimburse!.reference.meeting} />
            }
            {
                showDetailMerchantModal && <DetailMerchant data={reimburse!.reference.merchant} />
            }
        </>
    )
}

export { Reimbursement }